<template>
  <div class="user">

  </div>
</template>

<script>
export default {
  name: 'User'
}
</script>

<style scoped>
  .user{
    margin: 0px auto;
    max-width: 350px;
    position: relative;
    margin-top: 50px;
  }
</style>



// WEBPACK FOOTER //
// User.vue?65f20e83